import {
  INVITATION_OUTCOME_ALREADY_INVITED,
  INVITATION_OUTCOME_ALREADY_MEMBER,
  INVITATION_OUTCOME_INVALID_LINK,
  INVITATION_OUTCOME_REVOKED,
  INVITATION_OUTCOME_WRONG_ACCOUNT,
} from '../invitation.const'
import type { InvitationOperationResult } from '../invitation.interface'

export type InvitationOutcomeMessages = Partial<Record<string, string>>

export function mapInvitationOutcomeToMessage(
  result: InvitationOperationResult,
  messages: InvitationOutcomeMessages = {}
): string {
  const mapped = messages[result.outcome]
  if (mapped) {
    return mapped
  }

  if (result.message.trim()) {
    return result.message
  }

  switch (result.outcome) {
    case INVITATION_OUTCOME_ALREADY_INVITED:
      return 'An invitation is already pending for this email.'
    case INVITATION_OUTCOME_ALREADY_MEMBER:
      return 'This person is already a member.'
    case INVITATION_OUTCOME_WRONG_ACCOUNT:
      return 'Sign in with the invited email address to accept this invitation.'
    case INVITATION_OUTCOME_INVALID_LINK:
      return 'This invitation link is invalid.'
    case INVITATION_OUTCOME_REVOKED:
      return 'This invitation is no longer valid.'
    default:
      return 'Something went wrong. Please try again.'
  }
}
